// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1518":"4c28caa534500df1","4301":"f948ec1259b42956","5428":"0f7ef305c875af2d","9812":"0c56ee2ca59adcd9"}[chunkId] + ".js";
};